import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getActivityNotes(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/asset_management/activity_notes/`, oauthTokenHeader);
}
function getSingleActivityNote(oauthTokenHeader: string, note_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/activity_notes/${note_shared_uid}/`,
    oauthTokenHeader
  );
}
function postActivityNotes(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(`${apiUrl}/asset_management/activity_notes/`,data,oauthTokenHeader);
}

function getFilesItem(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(`${apiUrl}/utilities/file/${object_shared_uid}/`,oauthTokenHeader);
}

function fileUploadItem(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/file/${object_shared_uid}/`,data,oauthTokenHeader);
}

function updateActivityNote(oauthTokenHeader: string,data: any,note_shared_uid: string) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/activity_notes/${note_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getAllUsers(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/admin/users/?active_only=True/`,oauthTokenHeader);
};

function getAllDimensions(oauthTokenHeader: any) {
  return fetchWrapper.get(`${apiUrl}/asset_management/dimensions/`,oauthTokenHeader);
}

function postComment(
  oauthTokenHeader: string,
  data: any,
  note_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${note_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}
function getComment(oauthTokenHeader: string, note_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/comments/${note_shared_uid}/`,
    oauthTokenHeader
  );
}

function deleteComment(oauthTokenHeader: string, object_shared_uid: any, comment_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`, oauthTokenHeader);
}

function deleteActivityNote(oauthTokenHeader: string, note_shared_uid: any) {
  return fetchWrapper.delete(
    `${apiUrl}/asset_management/activity_notes/${note_shared_uid}/`,
    oauthTokenHeader
  );
}

function fileUploadME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}
function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(`${apiUrl}/utilities/file/${object_shared_uid}/`,oauthTokenHeader);
}

function putComments(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.put(`${apiUrl}/utilities/comments/${object_shared_uid}/`,data,oauthTokenHeader);
}

function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/file/${file_shared_uid}/`, oauthTokenHeader);
}

function getLabels(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/utilities/labels/`, oauthTokenHeader);
}

export const activityNotesService = {
  getActivityNotes,
  getSingleActivityNote,
  postActivityNotes,
  updateActivityNote,
  getFilesItem,
  fileUploadItem,
  getAllUsers,
  getAllDimensions,
  postComment,
  putComments,
  deleteComment,
  getComment,
  deleteActivityNote,
  fileUploadME,
  getFiles,
  deleteFile,
  getLabels
};
